import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import { CartDrawer } from "./components/CartDrawer";
import Admin from "./pages/Admin";
import Home from "./pages/Home";
import About from "./pages/About";
import Donate from "./pages/Donate";
import Merch from "./pages/Merch";
import Events from "./pages/Events";
import WhatsHappening from "./pages/WhatsHappening";
import Gallery from "./pages/Gallery";
import Sponsors from "./pages/Sponsors";
import Contact from "./pages/Contact";
import GetInvolved from "./pages/GetInvolved";
import { MobileDonateBar } from "./components/MobileDonateBar";

const PublicSite = () => (
    <div className="App">
        <ScrollToTop />
        <Navbar />
            <main>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/donate" element={<Donate />} />
                    <Route path="/merch" element={<Merch />} />
                    <Route path="/events" element={<Events />} />
                    <Route path="/whats-happening" element={<WhatsHappening />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/sponsors" element={<Sponsors />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/get-involved" element={<GetInvolved />} />
                </Routes>
            </main>
            <Footer />
            <MobileDonateBar />
            <CartDrawer />
        </div>
);

function App() {
    return (
        <SettingsProvider>
            <CartProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/*" element={<PublicSite />} />
                    </Routes>
                </BrowserRouter>
            </CartProvider>
        </SettingsProvider>
    );
}

export default App;
